/* eslint-disable camelcase */
import { useReactiveVar } from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import React, { useEffect, useState } from 'react';

const defaultObj = { frstThree: [], secThree: [], thirdThree: [] };

export const usePromoCompoentPosition = (props) => {
    const period = useReactiveVar(selectedPeriodVar);
    const { flatDishesList = [], dishesHashSum } = props;
    const [{ frstThree, secThree, thirdThree }, setLists] = useState(defaultObj);


    useEffect(() => {
        // console.log(period);
    }, [period]);

    useEffect(() => {
        // console.log(dishesHashSum, flatDishesList);
        setLists(() => {
            const v1 = flatDishesList.slice(0, 3).map((itm) => `${itm.id}:${itm.categoryId}`);
            const v2 = flatDishesList.slice(3, 6).map((itm) => `${itm.id}:${itm.categoryId}`);
            const v3 = flatDishesList.slice(6, 9).map((itm) => `${itm.id}:${itm.categoryId}`);
            return {
                frstThree: v1,
                secThree: v2,
                thirdThree: v3,
            };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dishesHashSum]);

    const updatePromoCompoentPosition = (next_id, next_cID) => {
        setLists((value) => {
            const frst = frstThree.filter((id) => {
                const [f_id] = id.split(':');
                return f_id !== next_id;
            });
            const sec = secThree.filter((id) => {
                const [f_id] = id.split(':');
                return f_id !== next_id;
            });
            const third = thirdThree.filter((id) => {
                const [f_id] = id.split(':');
                return f_id !== next_id;
            });

            const listed = flatDishesList.filter((itm) => itm.id !== next_id);
            // console.log(listed, flatDishesList);

            if (!frst.length) {
                return {
                    frstThree: listed.slice(0, 3).map((itm) => `${itm.id}:${itm.categoryId}`),
                    secThree: listed.slice(3, 6).map((itm) => `${itm.id}:${itm.categoryId}`),
                    thirdThree: listed.slice(6, 9).map((itm) => `${itm.id}:${itm.categoryId}`),
                };
            }

            if (!sec.length) {
                return {
                    frstThree: frst,
                    secThree: listed.slice(frst.length, frst.length + 3).map((itm) => `${itm.id}:${itm.categoryId}`),
                    thirdThree: listed.slice(6, 9).map((itm) => `${itm.id}:${itm.categoryId}`),
                };
            }

            if (!third.length) {
                return {
                    frstThree: frst,
                    secThree: sec,
                    thirdThree: third,
                };
            }
            return { frstThree: frst, secThree: sec, thirdThree: third };
        });
    };

    // console.log(frstThree, secThree, thirdThree);

    // console.log(list);

    // if (category === '3') {
    //     console.log(flatDishesList, list);
    // }


    return {
        thirdDishId: frstThree[frstThree.length - 1],
        fifthDishId: secThree[secThree.length - 2],
        sixthDishId: secThree[secThree.length - 1],
        seventhDishId: thirdThree[0],
        updatePromoCompoentPosition,
    };
};
